import {
  setGroup,
  setCategory,
  setMode,
  editGroup,
  selectGroupById,
  selectCurrentGroup,
  createGroup,
  deleteGroup,
  setSelectedStudent,
  setSearchQuery,
  setIsStudentRemovalDialogOpen,
  setIsShowDeleteGroupDialog,
} from "@app/routes/studentGroup/store/studentGroupSlice";
import { trackGroupEvent as TGE } from "./studentGroups";
import { CATEGORIES, MODES } from "@app/routes/studentGroup/constants";
import _ from "lodash";

export const relevantGroupsBeforeActions = {

};
    
export const relevantGroupsAfterActions = {
  [setGroup]: (stateBefore, stateAfter) => {
    TGE("view_group", stateAfter);
  },
  [setCategory]: (stateBefore, stateAfter, action) => {
    action.payload === CATEGORIES.ALL_STUDENTS.id && TGE("view_all_students", stateAfter);
  },
  [setMode]: (stateBefore, stateAfter, action) => {
    const eventDict = { [MODES.EDIT]: "open_edit_group", [MODES.CREATE]: "add_new_group" };
    TGE(eventDict[action.payload], stateAfter);
  },

  [editGroup.fulfilled]: (stateBefore, stateAfter, action) => {
    const group = selectGroupById(selectCurrentGroup(stateBefore).id)(stateBefore);
    const extraData = {
      is_name_changed: group.name !== action.payload.name,
      is_removed_students: !!_.difference(group.students, action.payload.students).length,
      is_added_students: !!_.difference(action.payload.students, group.students).length,
    };
    TGE("save_update_group", stateAfter, extraData);
  },

  [createGroup.fulfilled]: (stateBefore, stateAfter, action) => {
    TGE("save_new_group", stateAfter, { group_id: action.payload.id, num_students_in_group: action.payload.students.length });
  },

  [deleteGroup.fulfilled]: (stateBefore, stateAfter) => {
    TGE("delete_group", stateAfter, {}, null, stateBefore);
  },

  [setSelectedStudent]: (stateBefore, stateAfter, action) => {
    action.payload && TGE("enter_student_profile", stateAfter, { student_id: action.payload.id });
  },

  [setSearchQuery]: (stateBefore, stateAfter, action) => {
    !!action.payload.length && TGE("search_in_group", stateAfter);
  },
  [setIsStudentRemovalDialogOpen]: (stateBefore, stateAfter, action) => {
    action.payload && TGE("open_delete_student_dialog", stateAfter, { student_id: action.payload });
  },

  [setIsShowDeleteGroupDialog]: (stateBefore, stateAfter, action) => {
    action.payload && TGE("open_delete_group_dialog", stateAfter);
  },

};
